<footer class="app-footer px-4">

  <div class="container pt-4 pb-3">
    <div class="row g-4">

      <!-- Brand + lost pet helpline -->
      <div class="col-12 col-lg-4">
        <a routerLink="/" class="d-inline-block text-decoration-none">
          <img src="{{ logoUrl }}" alt="Logo" class="app-footer__logo" width="171" height="50">
        </a>

        <div class="mt-3">
          <p class="app-footer__lost-label mb-1">Lost a pet?</p>

          <a
            *ngIf="!isMember"
            href="tel:{{ companyPhoneNumber }}"
            class="app-footer__phone text-decoration-none fw-bold">
            {{ companyPhoneNumber }}
          </a>

          <ng-container *ngIf="isMember">
            <p class="app-footer__lost-text mb-1">
              As a member, you have access to our 24/7 helpline, which you can call on
            </p>
            <a
              href="tel:{{ companyMemberPhoneNumber }}"
              class="app-footer__phone text-decoration-none fw-bold">
              {{ companyMemberPhoneNumber }}
            </a>
          </ng-container>
        </div>
      </div>

      <!-- Link columns -->
      <div class="col-12 col-lg-8">
        <div class="row g-4">

          <div class="col-6 col-md-4" *ngIf="companyLinks.length">
            <p class="app-footer__col-title">Company</p>
            <ul class="list-unstyled d-flex flex-column gap-2 mb-0">
              <li *ngFor="let link of companyLinks">
                <a
                  [routerLink]="link.route"
                  [fragment]="link.fragment"
                  (click)="onLinkClick(link)"
                  class="app-footer__link text-decoration-none">
                  {{ link.name }}
                </a>
              </li>
            </ul>
          </div>

          <div class="col-6 col-md-4">
            <p class="app-footer__col-title">Legal</p>
            <ul class="list-unstyled d-flex flex-column gap-2 mb-0">
              <li *ngFor="let link of links">
                <a
                  [routerLink]="link.route"
                  (click)="onLinkClick(link)"
                  class="app-footer__link text-decoration-none">
                  {{ link.name }}
                </a>
              </li>
            </ul>
          </div>

          <div class="col-12 col-md-4">
            <p class="app-footer__col-title">Contact</p>
            <a href="mailto:{{ contactEmail }}" class="app-footer__link text-decoration-none">{{ contactEmail }}</a>
            <address class="app-footer__address mt-2 mb-0">
              Moorside, Monks Cross Drive,<br>
              Huntington, YORK<br>
              YO32 9LB
            </address>
          </div>

        </div>
      </div>

    </div>
  </div>

  <hr class="app-footer__divider mx-auto my-0">

  <div class="container py-3">
    <div class="d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3">
      <small class="app-footer__copyright text-center text-sm-start">
        {{ copyrightText }}
      </small>
      <div class="app-footer__social-icon-wrapper d-flex align-items-center">
        <app-social-twitter [badgeWrapperSize]="'28px'" [badgeIconSize]="'20px'"></app-social-twitter>
        <app-social-facebook [badgeWrapperSize]="'28px'" [badgeIconSize]="'20px'"></app-social-facebook>
        <app-social-instagram [badgeWrapperSize]="'28px'" [badgeIconSize]="'20px'"></app-social-instagram>
      </div>
    </div>
  </div>

</footer>
